// extracted by mini-css-extract-plugin
export default {"BottomLinks":"DetectedErrors_BottomLinks__V5KcR"};